/* eslint-disable jira/filename-case */
import type { History } from 'history';
import type { Location, DynamicRouteBrowserHistory } from './types.tsx';
import { createLegacyHistory } from './utils/create-legacy-history/index.tsx';

export const DEFAULT_MATCH = {
	params: {},
	isExact: false,
	path: '',
	url: '',
	query: {},
};

export const DEFAULT_ROUTE = {
	path: '',
	component: () => null,
	name: '',
};

export const DEFAULT_HISTORY: Omit<
	History<unknown>,
	'location' | 'go' | 'createHref' | 'push' | 'replace'
> & {
	location: Location;
	push: (path: string | Location, state?: unknown) => void;
	replace: (path: string | Location, state?: unknown) => void;
} & DynamicRouteBrowserHistory = createLegacyHistory();

export const DEFAULT_ACTION = 'POP';
